export default "__VITE_ASSET__9586a1ce__"